import compact from '@/utils/compact';
import type { SyncRequestSearchConditions } from './pickSyncRequestSearchConditions';

type ConditionTag = {
  key: string;
  label: string;
};

function quote(value: string) {
  return `「${value}」`;
}

export default function buildSyncRequestConditionTags(
  searchConditions: SyncRequestSearchConditions
): ConditionTag[] {
  const conditions = compact(searchConditions) as SyncRequestSearchConditions;
  const tags: ConditionTag[] = [];

  if (conditions.search_query) {
    tags.push({ key: 'search_query', label: `キーワード: ${quote(conditions.search_query)}` });
  }
  if (conditions.company_name) {
    tags.push({ key: 'company_name', label: `企業名: ${quote(conditions.company_name)}` });
  }
  if (conditions.job_position_name) {
    tags.push({
      key: 'job_position_name',
      label: `ポジション: ${quote(conditions.job_position_name)}`,
    });
  }
  if (conditions.working_location) {
    tags.push({
      key: 'working_location',
      label: `勤務地: ${quote(conditions.working_location)}`,
    });
  }

  if (conditions.salary) {
    tags.push({ key: 'salary', label: `年収: ${quote(`${conditions.salary}万円を含む`)}` });
  }

  if (conditions.min_salary || conditions.max_salary) {
    const min = conditions.min_salary ? `${conditions.min_salary}` : '';
    const max = conditions.max_salary ? `${conditions.max_salary}` : '';
    tags.push({
      key: 'salary_range',
      label: `年収: ${quote(`${min}〜${max}万円`)}`,
    });
  }

  if (conditions.salary_undisclosed) {
    tags.push({ key: 'salary_undisclosed', label: '年収未記載を含む' });
  }

  return tags;
}
